<template>
  <div>
    <InitialAvatarIcon
      v-if="
        instrumentType === InstrumentType.BDR ||
        instrumentType === InstrumentType.GlobalAssets
      "
      class="instrument-avatar__icon"
      :size="size"
      icon="CA0030"
    />
    <InitialAvatarIcon
      v-else-if="
        instrumentType === InstrumentType.FII ||
        instrumentType === InstrumentType.RealStateAssets
      "
      class="instrument-avatar__icon"
      :size="size"
      icon="CA0020"
    />
    <InitialAvatarChar v-else :size="size" :char="symbolInitial" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  InitialAvatarIcon,
  InitialAvatarChar
} from '@warrenbrasil/nebraska-web';

import { InstrumentType } from '@/modules/trade/types';

@Component({
  components: {
    InitialAvatarChar,
    InitialAvatarIcon
  }
})
export default class InstrumentAvatarFallback extends Vue {
  @Prop({ type: String, required: false })
  readonly instrumentType?: InstrumentType;

  @Prop({ type: String, required: true })
  readonly instrumentSymbol!: string;

  @Prop({ type: String, default: 'medium' })
  readonly size!: string;

  readonly InstrumentType = InstrumentType;

  get symbolInitial() {
    return this.instrumentSymbol[0];
  }
}
</script>

<style lang="less" scoped>
.instrument-avatar {
  &__icon {
    color: @element-secondary;
    background-color: @background-primary;
  }
}
</style>
